(function () {
  'use strict';

  angular
    .module('specsguardApp')
    .controller('ProjectModulesCtrl', ProjectModulesCtrl);

  ProjectModulesCtrl.$inject = ['$scope', 'Project', 'ProjectBusinessService', 'errorMessageService',
    'Labels'];

  function ProjectModulesCtrl ($scope, Project, ProjectBusinessService, errorMessageService,
    Labels) {

    const vm = this;


    vm.$onInit = function () {
      $scope.project = vm.project;
      $scope.update(vm.project);
    };

    $scope.LABELS = Labels;

    $scope.collapsible = {
      modules: true,
      submodules: true,
    };

    $scope.offset = 0;

    $scope.isLoading = true;

    const setHideChildren = (oldMod, newMod) => {
      if (oldMod && angular.isDefined(oldMod.hideChildren)) {
        return oldMod.hideChildren;
      } else if (!oldMod && angular.isDefined(newMod.submodules)) {
        return false;
      }

      return true;
    };

    $scope.update = function (updatedProject, updatedDataservice) {
      $scope.title = vm.tab==='pveStructuur' ? Labels.getLabel('pvestructure') : Labels.getLabel('specbookstructure');
      if (updatedDataservice) {
        vm.updateProject({project: updatedProject});
      }

      const isTechnical = vm.tab === 'pveStructuurTechnical';
      let newFilteredList = updatedProject.modules.filter((mod) =>
        isTechnical ? mod.isTechnicalType : !mod.isTechnicalType);

      $scope.list = newFilteredList.map((mod) => {
        const listMod = $scope.list && $scope.list.find((oldMod) => oldMod._id === mod._id);
        mod.hideChildren = setHideChildren(listMod, mod);

        mod.submodules = mod.submodules.map((submod) => {
          const listSubmod = listMod && listMod.submodules.find((oldSubmod) => oldSubmod._id === submod._id);
          submod.hideChildren = setHideChildren(listSubmod, submod);
          return submod;
        });
        return mod;
      });

      if (isTechnical) {
        $scope.offset = updatedProject.modules.length - $scope.list.length;
      }

      $scope.project = updatedProject;
      vm.project = updatedProject;
    };

    $scope.getBuildingName = function (constructionId) {
      return $scope.project.buildings.find(
        function (building) {
          return building._id === constructionId;
        }
      ).name;
    };

    $scope.getBasicAreaName = function (constructionId) {
      return $scope.project.basicAreas.find((basicArea) => basicArea._id === constructionId).name;
    };

    $scope.getAreaName = function (constructionId) {
      let name = '';
      $scope.project.buildings.find((building) =>
        building.clusters.find((cluster) => cluster.areas.find((area) => {
          if (area._id === constructionId) {
            name = area.name;
            return true;
          }
          return false;
        })));
      return name;
    };

    $scope.saveReorder = function (updatedModuleOrElement, type, list) {
      let params;
      let body;

      if (type === 'module') {
        updatedModuleOrElement.order += $scope.offset;

        params = {
          id: $scope.project._id,
          paramId: updatedModuleOrElement._id
        };
        body = {
          versionId: $scope.project.versionId,
          module: updatedModuleOrElement
        };
        return Project.updateModule(params, body).$promise;

      } else if (type === 'submodule') {
        const module = ProjectBusinessService.findModuleBySubmoduleId($scope.project, updatedModuleOrElement._id);
        params = {
          id: $scope.project._id,
          paramId: module._id,
          secondParamId: updatedModuleOrElement._id
        };
        body = {
          versionId: $scope.project.versionId,
          submodule: updatedModuleOrElement
        };
        return Project.updateSubModule(params, body).$promise;
      }

      const submodule = ProjectBusinessService.findSubModuleById($scope.project,
        updatedModuleOrElement.moduleId, updatedModuleOrElement.submoduleId);
      submodule.elements = list;
      delete submodule.order;

      params = {
        id: $scope.project._id,
        paramId: updatedModuleOrElement.moduleId,
        secondParamId: updatedModuleOrElement.submoduleId
      };
      body = {
        versionId: $scope.project.versionId,
        submodule: submodule
      };
      return Project.updateSubModule(params, body).$promise;
    };

    $scope.saveModuleDialogOptions = {
      title: Labels.getLabel('module'),

      fields: [
        {
          key: 'name',
          label: Labels.getLabel('modulename'),
          required: true,
          type: 'text'
        }
      ],

      save: function (form, instance) {
        let request;
        let reqBody = {
          _id: $scope.project._id,
          paramId: instance && instance._id,
          versionId: $scope.project.versionId,
          module: form,
        };

        // TODO replace this with Jaimy's / Milan's / Michiel's extention for simple dialog checkbox support
        reqBody.module.isTechnicalType = vm.tab === 'pveStructuurTechnical';

        if (instance) {
          request = Project.updateModule(reqBody);
        } else {
          request = Project.createModule(reqBody);
        }

        return request.$promise
          .then(function (newProject) {
            errorMessageService.showSuccess(Labels.getLabel('module') + ' ' + Labels.getLabel('succesfully') +
              ' ' + (instance ? Labels.getLabel('edited') : Labels.getLabel('created')));
            $scope.update(newProject, true);
          })
          .catch(function () {
            errorMessageService.showError(Labels.getLabel('errorduringthe') + ' ' +
              (instance ? Labels.getPlural('edit') : Labels.getLabel('creationof') + ' ' + Labels.getLabel('module')));
            return Labels.getLabel('errorcreationeditingmodule');
          });
      }
    };

  }
})();
